import React from 'react';
import c from 'classnames';
import { withSearchkitRouting } from '@searchkit/client';
var SearchPage = function SearchPage(_ref) {
  var className = _ref.className,
    children = _ref.children;
  // Adding euiPage className for backwards compatibility.
  var classNames = c('euiPage', className);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, children);
};
export var routeToStateFn = function routeToStateFn(routeState) {
  var value = {
    query: routeState.query || '',
    sortBy: routeState.sort || '',
    filters: routeState.filters || [],
    page: {
      size: Number(routeState.size) || 10,
      from: Number(routeState.from) || 0
    }
  };

  // Map Number values for min and max filters. By default they
  // are parsed as strings, which does not comply to the schema.
  // The 'qs' package is at fault here.
  // @see https://github.com/ljharb/qs/issues/91
  value.filters = value.filters.map(function (item) {
    if (item.min) {
      item.min = Number(item.min);
    }
    if (item.max) {
      item.max = Number(item.max);
    }
    if (item.boolValue) {
      item.boolValue = item.boolValue == 'true';
    }
    if (item.geoBoundingBox) {
      item.geoBoundingBox.topLeft.lat = Number(item.geoBoundingBox.topLeft.lat);
      item.geoBoundingBox.topLeft.lon = Number(item.geoBoundingBox.topLeft.lon);
      item.geoBoundingBox.bottomRight.lat = Number(item.geoBoundingBox.bottomRight.lat);
      item.geoBoundingBox.bottomRight.lon = Number(item.geoBoundingBox.bottomRight.lon);
    }
    if (item.geoRadius) {
      item.geoRadius.radius = Number(item.geoRadius.radius);
      item.geoRadius.center.lat = Number(item.geoRadius.center.lat);
      item.geoRadius.center.lon = Number(item.geoRadius.center.lon);
    }
    return item;
  });
  return value;
};
export default withSearchkitRouting(SearchPage, {
  routeToState: routeToStateFn
});